import React, { ReactNode } from "react";

interface CustomTooltipProps {
  children: ReactNode;
  arrowDirection?: "up" | "down" | "down-right";
  className?: string;
}

const CustomTooltip: React.FC<CustomTooltipProps> = ({ children, arrowDirection = "down", className }) => (
  <div className={`z-[50] flex flex-col justify-center ${arrowDirection === "down-right" ? "items-end" : "items-start"} ${className||""}`}>
    {arrowDirection === "up" && (
      <div className="w-0 h-0 border-l-8 border-r-8 border-b-8 border-l-transparent border-r-transparent border-b-white mb-1"></div>
    )}
    <div className="bg-white text-black text-lg font-semibold rounded px-6 py-4 shadow-lg min-w-[300px] max-w-[400px] text-center">
      {children}
    </div>
    {(arrowDirection === "down-right" || arrowDirection === "down" ) && (
      <div className="w-0 h-0 border-l-8 border-r-8 border-t-8 border-l-transparent border-r-transparent border-t-white mt-1"></div>
    )}
  </div>
);

export default CustomTooltip;
